import React, {
  ComponentPropsWithoutRef,
  ElementType,
  createContext,
  useContext,
} from 'react';

/** @type {React.Context<import('mapbox-gl').Map>} */
const MapContext = createContext<mapboxgl.Map | null>(null);
const useGlMap = (): mapboxgl.Map | null => useContext(MapContext);

interface MapContextProviderProps
  extends ComponentPropsWithoutRef<ElementType<any>> {
  value;
}

const MapContextProvider = ({ value, ...props }: MapContextProviderProps) => {
  if (!value) return null;
  return <MapContext.Provider value={value} {...props} />;
};

export { MapContextProvider, useGlMap };
